<div fxlayout="row" class="container" tabindex="0">
	<div class="items-wrapper">
			<div class="cloud-icon">
				<mat-icon fontSet="material-symbols-outlined" class="icon">web_asset_off</mat-icon>
			</div>
			<div class="info-msg">
					<div class="info-msg-1" tabindex="0">Sorry, this page doesn't exist.</div>
					<div class="info-msg-2" tabindex="0">Please go <a href="javascript:void(0);" (click)="back()" (keyup.enter)="back()" aria-label="back">back</a> and try again. If the issues persists, contact <a href = "mailto: tdmstudio@clarivate.com" class="email" aria-label="Email us at tdmstudio@clarivate.com">tdmstudio&#64;clarivate.com</a></div>
			</div>
</div>
